module.exports = __webpack_public_path__ + "static/media/coming.ed4fc388.png";